var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CTabs',{staticClass:"nav-tabs-boxed",attrs:{"variant":"tabs"}},[_c('CTab',{attrs:{"title":"Prioridades de Pedido"}},[_c('crud-base',{attrs:{"url":_vm.url,"columns":_vm.columns,"onDelete":() => {},"onUpdate":() => {},"onStore":() => {},"enableSearch":true,"checkAlerts":true,"formInputs":_vm.formInputs,"primaryKey":"id"},scopedSlots:_vm._u([{key:"cor",fn:function({ model }){return [(model.cor)?_c('span',{style:({
            display: 'inline-block',
            width: '20px',
            height: '20px',
            borderRadius: '4px',
            background: model.cor,
            border: '1px solid #ccc',
          })}):_vm._e()]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }